import { render, staticRenderFns } from "./SyncOrderError.vue?vue&type=template&id=5af0980e&scoped=true"
import script from "./SyncOrderError.vue?vue&type=script&lang=js"
export * from "./SyncOrderError.vue?vue&type=script&lang=js"
import style0 from "./SyncOrderError.vue?vue&type=style&index=0&id=5af0980e&prod&scoped=true&lang=css"
import style1 from "./SyncOrderError.vue?vue&type=style&index=1&id=5af0980e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0980e",
  null
  
)

export default component.exports